import * as React from 'react';
import { FiRepeat } from "react-icons/fi";
import { GiCalendar } from "react-icons/gi";
import { IoMdClose, IoIosArrowForward } from "react-icons/io";
import { GiAlarmClock } from "react-icons/gi";
import StarRatings from 'react-star-ratings';
import { CircularProgressbar } from 'react-circular-progressbar';
import Rater from 'react-rater';
import withServices from '../../HOCs/withServices'
import 'react-rater/lib/react-rater.css';

// icons
import 'font-awesome/css/font-awesome.min.css';

// styling
import 'bootstrap/dist/css/bootstrap.min.css';
import './assessmentViewPage.scss';

// toast
import 'react-toastify/dist/ReactToastify.css';

// flags
import 'flag-icon-css/css/flag-icon.css';

// components
import Loader from 'react-loader'

// router
import { Redirect } from "react-router-dom";

// components
import {Button, Col, Row} from 'reactstrap';

// toast component
import { toast, ToastContainer} from 'react-toastify';

import { CSSTransition } from 'react-transition-group'
import Modal from 'react-awesome-modal';

import 'react-circular-progressbar/dist/styles.css';

// main css
import './assessmentCompletedPage.css';
import NavBar from '../../components/CustomNav/CustomNav.Component';
import PlexLoader from '../../common/CustomLoader/customLoader.Component';

// services
import { createItemGen, currentBaseUrl, currentUser, getGeneralSmartTableData, isBasicPreassessmentDone, isUserLoggedIn, isUserUpgraded, currentLesson } from '../../common/services';

import lessonicon from '../../assets/images/courseicons/math-icon.png'
import { userInfo } from 'os';

interface IProps {
  isActive?: any;
  history?: any;
  services?: any;
}

const Smile = ({ isActive }: IProps) => {
  const color = isActive ? '#8BC34A': '#E3E3E3';
  return (
    <svg width="30px" height="30px" viewBox="0 0 526 526">
      <g fill="none" transform="translate(13.000000, 13.000000)">
        <circle
          id="Face"
          stroke={color}
          strokeWidth="25"
          cx="250"
          cy="250"
          r="250"
        />
        <circle id="Eye" fill={color} cx="150" cy="200" r="30" />
        <circle id="Eye" fill={color} cx="350" cy="200" r="30" />
        <path
          d="M150,330 C182.874349,356.234375 216.059245,369.351562 249.554688,369.351562 C283.05013,369.351562 316.85612,356.234375 350.972656,330"
          id="Mouth"
          stroke={color}
          strokeWidth="25"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
}

const Normal = ({ isActive }: IProps) => {
  const color = isActive ? '#8BC34A': '#E3E3E3';
  return (
    <svg width="30px" height="30px" viewBox="0 0 526 526">
      <g fill="none" transform="translate(13.000000, 13.000000)">
        <circle
          id="Face"
          stroke={color}
          strokeWidth="25"
          cx="250"
          cy="250"
          r="250"
        />
        <circle id="Eye" fill={color} cx="150" cy="200" r="30" />
        <circle id="Eye" fill={color} cx="350" cy="200" r="30" />
        <path
          d="M211,365.926862 L316.301059,327"
          id="Path-2"
          stroke={color}
          strokeWidth="25"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
}

const Angry = ({ isActive }: IProps) => {
  const color = isActive ? '#8BC34A': '#E3E3E3';
  return (
    <svg width="30px" height="30px" viewBox="0 0 526 526">
      <g fill="none" transform="translate(13.000000, 13.000000)">
        <circle
          id="Face"
          stroke={color}
          strokeWidth="25"
          cx="250"
          cy="250"
          r="250"
        />
        <path
          d="M146.766617,170 L178.873712,191.656509 C179.607424,194.254283 180,196.995188 180,199.827784 C180,216.396326 166.568542,229.827784 150,229.827784 C133.431458,229.827784 120,216.396326 120,199.827784 C120,184.351657 131.718691,171.612577 146.766617,170 Z"
          id="Combined-Shape"
          fill={color}
        />
        <path
          d="M346.766617,170 L378.873712,191.656509 C379.607424,194.254283 380,196.995188 380,199.827784 C380,216.396326 366.568542,229.827784 350,229.827784 C333.431458,229.827784 320,216.396326 320,199.827784 C320,184.351657 331.718691,171.612577 346.766617,170 Z"
          id="Combined-Shape"
          fill={color}
          transform="translate(350.000000, 199.913892) scale(-1, 1) translate(-350.000000, -199.913892) "
        />
        <path
          d="M150,330 C182.874349,356.234375 216.059245,369.351562 249.554688,369.351562 C283.05013,369.351562 316.85612,356.234375 350.972656,330"
          id="Mouth"
          stroke={color}
          strokeWidth="25"
          strokeLinecap="round"
          transform="translate(250.486328, 349.675781) scale(1, -1) translate(-250.486328, -349.675781) "
        />
      </g>
    </svg>
  );
}

class AssessmentCompletedPage extends React.Component<IProps>{
  public state = {
    baseurl: currentBaseUrl(),
    destination: '',
    navigate: false,
    todashboard: false,
    tologin: false,
    total: 0,
    modalIsOpen: false,
    rating: 0,
  }

  constructor(props) {
    super(props);
    this.onLogout = this.onLogout.bind(this);
    this.openWidget = this.openWidget.bind(this);
    this.onProfile = this.openWidget.bind(this);
    this.openHome = this.openHome.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.changeRating = this.changeRating.bind(this);
    this.feedbackModal = this.feedbackModal.bind(this);
  }
  public componentDidMount() {
    if(!isUserLoggedIn()){
      this.setState({ tologin: true });
    } else{
      this.setState({ username: currentUser()});
    }
    // console.log("Is upgrade: " + isUserUpgraded());
    if(!isUserUpgraded() || this.currentid()==='0') {
      this.setState({modalIsOpen: false});
    }
  }

  public openModal() {
    this.setState({ modalIsOpen: true });
  }

  public closeModal() {
    this.setState({ modalIsOpen: false });
  }

  public changeRating(newRating, name) {
    this.setState({ rating: newRating });
  }

  public openWidget(param, e) {
    // console.log('widget: ' + param)
    // this.setState({ destination: currentBaseUrl()  + 'preassessmentresult/'  + param });
    this.setState({ navigate: true, destination: `${currentBaseUrl()}home` });
    // console.log("AFTER ASSESSMENT" + this.state.destination);
  }

  public openHome(e) {
    this.setState({ destination: currentBaseUrl()  + 'home' });
    this.setState({ navigate: true });
    // console.log("AFTER ASSESSMENT" + this.state.destination);
  }

  public onLogout(arg) {
    // console.log('Logout in Parent', arg);
    this.setState({ tologin: true });
  }

  public onProfile() {
    this.setState({navigate: true, destination: currentBaseUrl() + "profile"})
  }

  public toDataCenter () {
    this.setState({navigate: true, destination: currentBaseUrl() + 'datacentre'})
  }

  public currentid (){
    const key1 = 'match';
    return this.props[key1].params.id
  }



  public actionbuttons() {
    if(isUserUpgraded()) {
      return (
        <Row className="button-list">
          <button className="completed-button green-button" onClick={this.openHome}>My Dashboard</button>
          <br/>
        </Row>
      );
    }
    else{
      return (
        <Row className="button-list">
          <button className="completed-button green-button" onClick={this.openWidget.bind(this, 'student')} > My Assessment</button>
          <br/>
          {/* <button className="completed-button green-button" >My Parent's Assessment</button>
          <br/>
          <button className="completed-button green-button" > My School's Assessment</button>
          <br/> */}
        </Row>
      );
    }
  }

  public feedbackModal() {
   
    if(isUserUpgraded() && isBasicPreassessmentDone() && this.currentid()!=='0') { 
      const progressStyles = {
      path: {
        stroke: "#acff24"
      },
      trail: {
        stroke: "#000"
      },
      text: {
        fill: "#acff24"
      }
    }
      return(
        <div className="success-modal" style={{background: "#ff0033"}}>
          <Modal
            visible={this.state.modalIsOpen}
            effect="fadeInUp"
            backgroundColor="blue"
            styles={{ backgroundColor : 'transparent' }}
            container={{ background: '#ff0033' }}
            onClickAway = {this.closeModal}
          >
            <div className="success-modal-container">
              <div className="success-modal-content">
                <div className="success-modal-content-header">
                  <img src={lessonicon} alt="Lesson Icon"/>
                  <h1>Here's how you performed</h1>
                </div>
                <h5><span>Wow! </span>You nailed this lesson!</h5>
                <div className="success-modal-content-statistics">
                  <div className="stats-col">
                    <h6>Questions Answered</h6>
                    <CircularProgressbar value={100} text={`${100}%`} styles={progressStyles}/>
                  </div>
                  <div className="stats-col">
                    <h6>Interactions Score</h6>
                    <CircularProgressbar value={75} text={`${75}%`} styles={progressStyles}/>
                  </div>
                  <div className="stats-col">
                    <h6>Assessment Score</h6>
                    <CircularProgressbar value={78} text={`${78}%`} styles={progressStyles} />
                  </div>
                  <div className="stats-col">
                    <div className="stat-more-info">
                      <FiRepeat size="36px" color="#ff0033"/>
                      <p>5 attempts</p>
                    </div>
                    <div className="stat-more-info">
                      <GiAlarmClock size="36px" color="#ff0033" />
                      <p>1h 4m 9s</p>
                    </div>
                    <div className="stat-more-info">
                      <GiCalendar size="36px" color="#ff0033"/>
                      <p>11/10/2019</p>
                    </div>
                  </div>
                </div>
                <div className="success-modal-content-buttons">
                  <button className="blue-button">LEARN MORE ABOUT YOUR PERFORMANCE</button>
                  <button className="blue-button" onClick = {this.toDataCenter}>SEE ALL YOUR RESULTS</button>
                </div>
                <IoMdClose size="32px" onClick={this.closeModal} className="modal-close" />
              </div>
              <div className="success-modal-sidebar">
                <div className="modal-sidebar-item">
                  <h6>How would you rate the content?</h6>
                  <StarRatings
                    rating={this.state.rating}
                    starRatedColor="#acff24"
                    starHoverColor="#75db00"
                    changeRating={this.changeRating}
                    numberOfStars={5}
                    name='rating'
                    starSpacing="2px"
                    starDimension="30px"
                  />
                </div>
                <div className="modal-sidebar-item">
                  <h6>How do you feel?</h6>
                  <Rater total={5}>
                    <Angry />
                    <Normal />
                    <Smile />
                    <Normal />
                    <Smile />
                  </Rater>
                </div>
                <div className="modal-sidebar-item">
                  <h6>Add this lesson to your training?</h6>
                  <IoIosArrowForward size="45px" />
                </div>
                <div className="modal-sidebar-item">
                  <h6>Your next Performance Learning Pathway</h6>
                  <p>Next Lesson Name</p>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      )
    }else {
      return "";
    }
  }

  public render() {
    if (this.state.tologin === true) {
     return <Redirect to='/login'/>
    }

    if (this.state.navigate === true) {
      return <Redirect to={this.state.destination}/>
    }

    const Styles = {
      toast:{
        zIndex: 9999999,
      },
      welcometext: {
        margin: 0,
        marginTop: '2%',
      },
    }

    return (
      <div>
        <NavBar logoutParent={this.onLogout} profileParent={this.onProfile} />
        <ToastContainer style={Styles.toast} />
        {/* {this.nextButton()} */}
        <CSSTransition
          in={true}
          appear={true}
          classNames="fade"
          timeout={800}
        >
          <div className="assessment-complete-container">
            <p className="thank-you">Thank you!</p>
            <p className="you-completed">
                {`You completed the assessment successfully.`}
                <br />
                {`To see the results, please choose an option`}
            </p>
            <br/>
            {this.actionbuttons()}
            {/* <PlexLoader />  to be revised*/}
          </div>
        </CSSTransition>

        {isUserUpgraded() ? this.feedbackModal() : ""}
        
      </div>
    );
  }
}

export default withServices(AssessmentCompletedPage);



// WEBPACK FOOTER //
// ./src/pages/Assessments/assessmentCompletedPage.component.tsx